// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/journal-entries/create-journal-entry',
        component: () =>
            import('@/pages/[organisation]/accounting/journal-entries/create-journal-entry.vue'),
        name: 'accounting.journal-entries.create-journal-entry',
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: 'access.accounting.general-ledger.create-manual-journal-entry',
        },
    },
];
